__turbopack_context__.v({
  "accordionSlideOverwrite": "partnerPreviewCard-module-scss-module__JqSDQW__accordionSlideOverwrite",
  "avatar": "partnerPreviewCard-module-scss-module__JqSDQW__avatar",
  "avatarImage": "partnerPreviewCard-module-scss-module__JqSDQW__avatarImage",
  "card": "partnerPreviewCard-module-scss-module__JqSDQW__card",
  "descriptionText": "partnerPreviewCard-module-scss-module__JqSDQW__descriptionText",
  "fadeIn": "partnerPreviewCard-module-scss-module__JqSDQW__fadeIn",
  "fadeOut": "partnerPreviewCard-module-scss-module__JqSDQW__fadeOut",
  "info": "partnerPreviewCard-module-scss-module__JqSDQW__info",
  "learnMore": "partnerPreviewCard-module-scss-module__JqSDQW__learnMore",
  "loadingContainer": "partnerPreviewCard-module-scss-module__JqSDQW__loadingContainer",
  "name": "partnerPreviewCard-module-scss-module__JqSDQW__name",
  "scaleIn": "partnerPreviewCard-module-scss-module__JqSDQW__scaleIn",
  "scaleOut": "partnerPreviewCard-module-scss-module__JqSDQW__scaleOut",
  "zoomIn": "partnerPreviewCard-module-scss-module__JqSDQW__zoomIn",
  "zoomOut": "partnerPreviewCard-module-scss-module__JqSDQW__zoomOut",
});
